import dayjs from "dayjs";
import { ItemListTy } from "../config/types";
import { MenuItem } from "../components/Layout/SideBarList";


export const getItemList=(data:string[]):   ItemListTy[] =>{
    return data.map((user) => ({
        value: user,
        label: user,
    }));

}



export const formatDate = (value: string) => {
  const to_date = dayjs(value);
  
  if (!to_date.isValid()) return "-- | --";
  
  const hasTime = value.includes("T") || value.includes(":");
  
  return hasTime 
    ? to_date.format("MMM D, YYYY h:mm A") 
    : to_date.format("MMM D, YYYY");   
};

export function formatSnakeCaseToReadable(input: string, ignorePrefix: string = 'is_'): string {
    if (!input) return input;
    if (input.startsWith(ignorePrefix)) {
      input = input.slice(ignorePrefix.length);
    }
    return input
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  export const formatStrinToReadable = (value: string | number): string => {
    const __value=(value.toString()).trim()
    return __value.charAt(0).toUpperCase() + __value.slice(1).toLowerCase();
  }


  interface NavItemState {
    isMainMenuSelected: boolean;
    isSubMenuSelected: boolean;
  }
  
  export const getNavItemState = (menu: MenuItem, currentPath: string): NavItemState => {
    const { path, children = [] } = menu;
  
    const isMainMenuSelected = path === currentPath;
    const isSubMenuSelected = children.some(child => child.path === currentPath);
  
    return {
      isMainMenuSelected,
      isSubMenuSelected,
    };
  };
  
  export function generateYears(startYear: number = 2010): number[] {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
  
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
  
    return years;
  }

  export function recordToChartData(record: Record<string, number>) {
    const xLabels = Object.keys(record);
    const yData = Object.values(record);
    return { yData, xLabels };
  }


  type ANY=string | boolean | number
export function formatRecordKeys(record: Record<string, ANY>) {
  const formatted: Record<string, ANY> = {};

  for (const [key, value] of Object.entries(record)) {
  
    let readable = key.replace(/[_-]/g, " ");
    readable = readable.replace(/([a-z])([A-Z])/g, "$1 $2");
    readable = readable
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    formatted[readable] = value;
  }

  return formatted;
}


type LabeledValue = {
  label: string;
  value: number;
};


export function recordToLabeledArray(record: Record<string, number>): LabeledValue[] {
  return Object.entries(record).map(([key, value]) => {
    let readable = key.replace(/[_-]/g, " ");
    readable = readable.replace(/([a-z])([A-Z])/g, "$1 $2");
    readable = readable
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return { label: readable, value };
  });
}
